import types from './types';

const initialState = {
  name: '',
  dates: [],
  entities: [],
  meals: [],
  savingMenu: false,
  successfulCreation: false,
  errorMessage: ''
};

export const newMenuReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_NEW_MENU_DATES: {
      return {
        ...state,
        dates: [...action.dates]
      };
    }
    case types.SET_NEW_MENU_ENTITIES: {
      return {
        ...state,
        entities: [...action.entities]
      };
    }
    case types.SET_NEW_MENU_NAME: {
      return {
        ...state,
        name: action.name
      };
    }
    case types.SET_NEW_MENU_MEALS: {
      return {
        ...state,
        meals: [...action.meals]
      };
    }
    case types.CREATE_NEW_MENU_REQUEST: {
      return {
        ...state,
        savingMenu: true,
        successfulCreation: false,
        errorMessage: ''
      };
    }
    case types.CREATE_NEW_MENU_SUCCESS: {
      return {
        ...state,
        savingMenu: false,
        successfulCreation: true,
        errorMessage: '',
        name: '',
        dates: [],
        entities: [],
        meals: []
      };
    }
    case types.CREATE_NEW_MENU_FAILURE: {
      return {
        ...state,
        savingMenu: false,
        successfulCreation: false,
        errorMessage: action.error
      };
    }
    default:
      return state;
  }
};
